import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { catchError, throwError } from "rxjs";
import { MessageEnum } from "../utils/message.enum";
import { ConfigService } from "./config/config.service";
import { clearAuthHandshakeStorage } from "./keycloak/auth-token-storage";
import { ToasterService } from "./toaster-service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloakService = inject(KeycloakService);
  const toaster = inject(ToasterService);
  const router = inject(Router);
  const configService = inject(ConfigService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        console.log("Interceptor detected 401", error);
        clearAuthHandshakeStorage();
        keycloakService.logout(configService.getLogoutRedirectUrl());
        toaster?.pop({ type: 'error', text: MessageEnum.SESSION_TIMEOUT });
      }
      
      // Handle 400 errors with "Unauthorized: User access required" message
      if (error.status === 400) {
        const errorMessage = error?.error?.message || '';
        if (errorMessage.includes('Unauthorized: User access required')) {
            router.navigate(['/user/project']);
        }
      }
      
      return throwError(() => error);
    })
  );
};
